// 시스템관리 - 시스템관리
import { Route, Switch } from 'react-router-dom';
import { lazy, Suspense } from 'react';


const RSY31 = lazy(() => import('@/pages/C02/RSY31'));  // 프로그램 등록화면
const RSY32 = lazy(() => import('@/pages/C02/RSY32'));  // 사용현황
const RSY40 = lazy(() => import('@/pages/C02/RSY40'));  // 납품서 이력현황
const RSY41 = lazy(() => import('@/pages/C02/RSY41'));  // 코드관리
const RSY42 = lazy(() => import('@/pages/C02/RSY42'));  // 출하전송 현황
const RSY43 = lazy(() => import('@/pages/C02/RSY43'));  // 상단공지
const RSY44 = lazy(() => import('@/pages/C02/RSY44'));  // 팝업관리

function C02() {
  return ( 
    <Suspense fallback={null}>
      <Switch>
        <Route path="/C02/RSY31" component={RSY31} />
        <Route path="/C02/RSY32" component={RSY32} />
        <Route path="/C02/RSY40" component={RSY40} />
        <Route path="/C02/RSY41" component={RSY41} />
        <Route path="/C02/RSY42" component={RSY42} />
        <Route path="/C02/RSY43" component={RSY43} />
        <Route path="/C02/RSY44" component={RSY44} />    
      </Switch>
    </Suspense>
  );
}

export default C02;
